/* eslint-disable @typescript-eslint/no-explicit-any */
import { OrbisErrorData } from '@orbis-systems/orbis-api-clients/orbis';

const isErrorResponse = (e: any): e is { response: { data: { error: string } } } => {
    return (
        typeof e === 'object' &&
        e !== null &&
        'response' in e &&
        typeof (e as any).response === 'object' &&
        'data' in (e as any).response &&
        typeof (e as any).response.data === 'object' &&
        'error' in (e as any).response.data &&
        typeof (e as any).response.data.error === 'string'
    );
};

export const isOrbisErrorData = (e: any): e is OrbisErrorData => {
    return (
        typeof e === 'object' && e !== null && 'orbisErrorCode' in e && typeof (e as any).orbisErrorCode === 'string'
    );
};

const errorRules: { match: (code: string) => boolean; message: string }[] = [
    {
        match: (code) => code.includes('ERR_TOO_SMALL_FOR_AON'),
        message: `The order quantity is too small to be placed as 'All or None'. Please increase the quantity or select a different fill type.`,
    },
    {
        match: (code) => code.includes('ERR_INSUFFICIENT_FUNDS') || code.includes('ERR_INSUFFICIENT_CASH'),
        message: `Selected account does not have enough funds to cover the order, or the trading limit has been exceeded.`,
    },
];

export const formatOrderPreviewErrorMessage = (e: unknown) => {
    const errorCode = isErrorResponse(e) ? e.response.data.error : '';

    const matchedRule = errorRules.find((rule) => rule.match(errorCode));

    if (matchedRule) {
        return matchedRule.message;
    }

    if (isOrbisErrorData(e)) {
        return e.orbisErrorCode;
    }

    return errorCode;
};
